import { render, staticRenderFns } from "./ReturnedData.vue?vue&type=template&id=1c6a5140"
import script from "./ReturnedData.vue?vue&type=script&lang=js"
export * from "./ReturnedData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports